import api from "./client";

export const getContainerDetails = (containerNo) =>
  api.get(`/api/container/${containerNo}`);

export const acceptContainer = (acceptanceID, acceptedWeight, userId) =>
  api.post(`/api/container/accept`, {
    acceptanceID,
    acceptedWeight,
    userId,
  });

export const reportContainerDamaged = (payload) =>
  api.post("/api/container/report-container-damaged", payload);




